import { render, staticRenderFns } from "./BooksListZh.vue?vue&type=template&id=acd7e990&scoped=true&"
import script from "./BooksListZh.vue?vue&type=script&lang=js&"
export * from "./BooksListZh.vue?vue&type=script&lang=js&"
import style0 from "./BooksListZh.vue?vue&type=style&index=0&id=acd7e990&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd7e990",
  null
  
)

export default component.exports